import React, { FC, useState } from 'react';

import moment from 'moment';

import { AppLayoutTop } from 'components/appComponents';
import { TabPanel } from 'devextreme-react';

import { DateRangePicker, DetailList, MainList } from '..';


const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const tabs = [
  {
    name: 'Основная информация',
    index: 0,
  },
  {
    name: 'Детализация',
    index: 1,
  },
];


const ComingFare: FC = () => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const [dateBegin, setDateBegin] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [transportId, setTransportId] = useState<number | null>(null);
  const [transportName, setTransportName] = useState<string>('');

  return (
    <div>
      <AppLayoutTop title="">
        <DateRangePicker
          dateBegin={dateBegin}
          dateEnd={dateEnd}
          transport={transportId}
          //@ts-ignore
          onChangeDateBegin={setDateBegin}
          //@ts-ignore
          onChangeDateEnd={setDateEnd}
          onChangeTarsport={setTransportId}
          onChangeTarsportName={setTransportName}
        />
      </AppLayoutTop>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={(e) => {
          if (e.name === 'selectedIndex') {
            setSelectedIndex(e.value);
          }
        }}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
      />
      {selectedIndex === 0 && (
        <div className="tab-content">
          <MainList dateBegin={dateBegin} dateEnd={dateEnd} transportId={transportId} transportName={transportName} />
        </div>
      )}
      {selectedIndex === 1 && (
        <div className="tab-content">
          <DetailList dateBegin={dateBegin} dateEnd={dateEnd} transportId={transportId} />
        </div>
      )}
    </div>
  );
};

export default ComingFare;
